(ns splash.ui.lender-portal.components.theme
  (:require
    [reagent-mui.colors :as colors]))

(def catskill-white "#f5f8fa")
(def section-header-background "#E5EDF2")

(def splash-colors
  {:black  {:main         "#000000"
            :light        "#000000"
            :dark         "#000000"
            :contrastText "#FFFFFF"}
   :white  {:main         "#FFFFFF"
            :light        "#FFFFFF"
            :dark         "#FFFFFF"
            :contrastText "#000000"}
   :teal   {:main         "#2BC2A1"
            :light        "#55ceb3"
            :dark         "#2BC2A1"
            :contrastText "#000000"}
   :purple {:main         "#C562FF"
            :light        "rgba(197, 98, 255, 0.87)"
            :dark         "#C562FF"
            :contrastText "#8944b2"}
   :yellow {:main         "#E4FF45"
            :light        "#e9ff6a"
            :dark         "#E4FF45"
            :contrastText "#9fb230"}
   :gray   {:main        "rgba(31, 31, 31, 1)"
            :light       "rgba(114, 114, 114, 1)"
            :translucent "rgba(114, 114, 114, 0.2)"}})

(def theme
  {:palette    {:primary   (:black splash-colors)
                :secondary (:teal splash-colors)
                :error     colors/red
                :warning   colors/yellow
                :info      (:white splash-colors)
                :success   colors/green}
   :components {:MuiButton {:variants [{:props {:variant :contained}
                                        :style {:backgroundColor (get-in splash-colors [:purple :main])
                                                :color "black"
                                                "&:hover" {:backgroundColor "white"}}}
                                       {:props {:variant :text}
                                        :style {:textTransform "none"
                                                :justifyContent "left"}}]}
                :MuiTypography    {:variants [{:props {:variant :sectionTitle}
                                               :style {:fontFamily     "Roboto, Helvetica, Arial, sans-serif"
                                                       :fontSize "16px"
                                                       :fontWeight "600"
                                                       :lineHeight "24px"}}
                                              {:props {:variant :cardTitle}
                                               :style {:fontFamily     "Roboto, Helvetica, Arial, sans-serif"
                                                       :fontSize "14px"
                                                       :fontWeight "600"
                                                       :lineHeight "24px"}}]}
                :MuiTableRow      {:styleOverrides {:root {"&.active" {:backgroundColor (get-in splash-colors [:gray :translucent])}}}}
                :MuiDataGrid {:styleOverrides {:columnHeader {"& .MuiDataGrid-columnHeaderTitle" {:font-weight 600}}
                                               :root {"& ::-webkit-scrollbar" {:width "6px"}
                                                      "& ::-webkit-scrollbar-thumb" {:borderRadius "10px"
                                                                                     :boxShadow "inset 0 0 6px rgba(0,0,0,.3)"}}}}}})

(def navbar
  {:palette    {:primary   (:black splash-colors)
                :secondary (:teal splash-colors)
                :error     colors/red
                :warning   colors/orange
                :info      colors/grey
                :action    {:disabled "#aaaaaa"}}
   :components {:MuiPaper      {:styleOverrides {:root {:backgroundColor (get-in splash-colors [:black :main])}}}
                :MuiAppBar     {:styleOverrides {:root {:color (get-in splash-colors [:white :main])}}}
                :MuiButtonBase {:styleOverrides {:root {:color          (get-in splash-colors [:white :main])
                                                        :text-transform "uppercase"}}}
                :MuiTypography {:styleOverrides {:root {:color (get-in splash-colors [:white :main])}}}
                :MuiLink       {:styleOverrides {:root {:color (get-in splash-colors [:white :main])
                                                        :hover {:text-decoration :none}}}}
                :MuiButton {:variants [{:props {:variant :contained}
                                        :style {:backgroundColor (get-in splash-colors [:purple :main])
                                                :color "black"
                                                "&:hover" {:backgroundColor "white"}}}]}}})

(defn no-rows-found-illustration
  []
  [:svg {:xmlns       "http://www.w3.org/2000/svg"
         :width       96
         :viewBox     "0 0 452 257"
         :aria-hidden "true"
         :focusable   "false"}
   [:path {:class "no-rows-primary"
           :style {:fill "#AEB8C2"}
           :d     "M348 69c-46.392 0-84 37.608-84 84s37.608 84 84 84 84-37.608 84-84-37.608-84-84-84Zm-104 84c0-57.438 46.562-104 104-104s104 46.562 104 104-46.562 104-104 104-104-46.562-104-104Z"}]
   [:path {:class "no-rows-primary"
           :style {:fill "#AEB8C2"}
           :d     "M308.929 113.929c3.905-3.905 10.237-3.905 14.142 0l63.64 63.64c3.905 3.905 3.905 10.236 0 14.142-3.906 3.905-10.237 3.905-14.142 0l-63.64-63.64c-3.905-3.905-3.905-10.237 0-14.142Z"}]
   [:path {:class "no-rows-primary"
           :style {:fill "#AEB8C2"}
           :d     "M308.929 191.711c-3.905-3.906-3.905-10.237 0-14.142l63.64-63.64c3.905-3.905 10.236-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142l-63.64 63.64c-3.905 3.905-10.237 3.905-14.142 0Z"}]
   [:path {:class "no-rows-secondary"
           :style {:fill "#E8EAED"}
           :d     "M0 10C0 4.477 4.477 0 10 0h380c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 20 0 15.523 0 10ZM0 59c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 69 0 64.523 0 59ZM0 106c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 153c0-5.523 4.477-10 10-10h195.5c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 200c0-5.523 4.477-10 10-10h203c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 247c0-5.523 4.477-10 10-10h231c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10Z"}]])

(defn no-rows-search-illustration
  []
  [:svg {:xmlns       "http://www.w3.org/2000/svg"
         :width       96
         :viewBox     "0 0 523 299"
         :aria-hidden "true"
         :focusable   "false"}
   [:path {:class "no-rows-primary"
           :style {:fill "#AEB8C2"}
           :d     "M262 20c-63.513 0-115 51.487-115 115s51.487 115 115 115 115-51.487 115-115S325.513 20 262 20ZM127 135C127 60.442 187.442 0 262 0c74.558 0 135 60.442 135 135 0 74.558-60.442 135-135 135-74.558 0-135-60.442-135-135Z"}]
   [:path {:class "no-rows-primary"
           :style {:fill "#AEB8C2"}
           :d     "M348.929 224.929c3.905-3.905 10.237-3.905 14.142 0l56.569 56.568c3.905 3.906 3.905 10.237 0 14.143-3.906 3.905-10.237 3.905-14.143 0l-56.568-56.569c-3.905-3.905-3.905-10.237 0-14.142Z"}]
   [:path {:class "no-rows-secondary"
           :style {:fill "#E8EAED"}
           :d     "M0 43c0-5.523 4.477-10 10-10h100c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 53 0 48.523 0 43ZM0 89c0-5.523 4.477-10 10-10h80c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 99 0 94.523 0 89ZM0 135c0-5.523 4.477-10 10-10h74c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 181c0-5.523 4.477-10 10-10h80c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM0 227c0-5.523 4.477-10 10-10h100c5.523 0 10 4.477 10 10s-4.477 10-10 10H10c-5.523 0-10-4.477-10-10ZM523 227c0 5.523-4.477 10-10 10H413c-5.523 0-10-4.477-10-10s4.477-10 10-10h100c5.523 0 10 4.477 10 10ZM523 181c0 5.523-4.477 10-10 10h-80c-5.523 0-10-4.477-10-10s4.477-10 10-10h80c5.523 0 10 4.477 10 10ZM523 135c0 5.523-4.477 10-10 10h-74c-5.523 0-10-4.477-10-10s4.477-10 10-10h74c5.523 0 10 4.477 10 10ZM523 89c0 5.523-4.477 10-10 10h-80c-5.523 0-10-4.477-10-10s4.477-10 10-10h80c5.523 0 10 4.477 10 10ZM523 43c0 5.523-4.477 10-10 10H413c-5.523 0-10-4.477-10-10s4.477-10 10-10h100c5.523 0 10 4.477 10 10Z"}]])
